import { beginScanSession, markSignupStarted } from '../utils/productAnalytics';

const NonLoggedComponent = () => {
  const handleLoginCta = source => {
    beginScanSession({ source: source.includes('gallery') ? 'gallery' : 'camera', entryPoint: 'hero' });
    markSignupStarted(source);
    window.location.href = '/login';
  };

  return (
  <section className="auth-prompt">
    <div className="landing-intro">
      <div className="landing-pill">Try it for free. Powered by our smartest models</div>
      <h1 className="landing-title">Visualize your menu with images</h1>
      <p className="landing-description">
        Take a picture of your menu and get pictures, nutrition, and allergen hints for each dish.
      </p>
    </div>

    <div className="preview-section landing-preview-section">
      <div className="preview-header">
        <div className="preview-title-group">
          <h3 className="preview-title">How Menu AI works</h3>
        </div>
      </div>
      <div className="preview-image-container">
        <video className="promo-preview-video" controls playsInline preload="metadata">
          <source src="/promo_video.mp4" type="video/mp4" />
        </video>
      </div>
    </div>

    <div className="landing-upload-actions">
      <button onClick={() => handleLoginCta('landing_camera')} className="upload-image-button scan-button">
        <span className="camera-icon">📸</span>
        <span className="button-text">Scan Menu</span>
      </button>
      <button onClick={() => handleLoginCta('landing_gallery')} className="upload-image-button gallery-upload-button">
        <span className="camera-icon">🖼️</span>
        <span className="button-text">Upload your menu</span>
      </button>
    </div>

    <nav className="landing-link-strip" aria-label="Popular Menu AI pages">
      <a href="/menu-scanner">Menu scanner</a>
      <a href="/menu-to-image">Menu to images</a>
      <a href="/menu-ocr">Menu OCR</a>
      <a href="/for-restaurants">For restaurants</a>
      <a href="/blog">Guides</a>
    </nav>
  </section>
  );
};

export default NonLoggedComponent;
